import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource1';
import {
  IAppointmentType,
  IAvailableTime,
  IAvailableTimes,
  IStudentService,
  IStudentServiceCategory
} from '../types/appointment_interfaces';
import { ILocation } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IAppointmentsAvailableTimesQueryResult {
  availableTimesList: moment.Moment[];
  flattenAvailableTimes: IAvailableTime[];
  canViewDropons: boolean;
  canRequest: boolean;
}

export class AppointmentsAvailableTimesQuery implements IQuery {
  private _result: IAppointmentsAvailableTimesQueryResult;

  constructor(
    private ngAppointmentAvailableTimesDatasource1: IAppointmentAvailableTimesDatasource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource
  ) {
    ORMMediator.registerQuery(this, ngAppointmentAvailableTimesDatasource1);
  }

  run(): this {
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    const selectedLocation: ILocation = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation;
    const availableTimes: IAvailableTimes[] = this.ngAppointmentAvailableTimesDatasource1.values();
    const flattenAvailableTimes: IAvailableTime[] = _4.reduce(
      availableTimes,
      (result: IAvailableTime[], value: IAvailableTimes) => result.concat(value.allTimes),
      [] as IAvailableTime[]
    );
    const availableTimeRanges: string[] = _4.map(flattenAvailableTimes, (time: IAvailableTime) => time.range);
    const availableTimesList: moment.Moment[] = _4.map(availableTimeRanges, (range: string) =>
      moment.unix(_4.toNumber(_4.head(_4.split(range, '_'))))
    );
    const canViewDropons = selectedLocation.can_view_dropins;
    const canRequest = selectedType.can_request && selectedLocation.can_request;
    this._result = {
      availableTimesList,
      flattenAvailableTimes,
      canViewDropons,
      canRequest
    };
    return this;
  }

  get result(): IAppointmentsAvailableTimesQueryResult {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_available_times_query.ts